import axios from 'axios';

export default function assignWireCategory(wireId, categoryId) {
  return axios.post(`/api/v1/wire/${wireId}/assign/category/${categoryId}`);
}
